import  { Component } from '@angular/core';
import { NavController, AlertController} from 'ionic-angular';
import { AuthService } from './../../providers/auth-service';
import { SharedComponent } from '../../shared/shared';
import { RegisterPage } from './register';
import { CommonService } from './../../services/common.service';



@Component({
  templateUrl:'forgot.html'
})

export class ForgotComponent  {
	
	

	/*ForgotBtnClick(event){
		alert();
		this.navCtl.push(HelloIonicPage);

	}*/

  $onInit = () => { };
  registerCredentials = { email: '', password: '' };

  constructor(private nav: NavController, private auth: AuthService, private alertCtrl: AlertController,public sharedClass:SharedComponent, private commonService:CommonService) { }

  public createAccount() {
    this.nav.push(RegisterPage);
  }

  public forgot() {

    this.commonService.showLoading();

    this.auth.forgotPassword(this.registerCredentials).subscribe(allowed => {
    	
      if (allowed) {        

        //if logged-in user is not supper admin
        this.registerCredentials.email='';
        this.commonService.dismisshowoading();
        this.commonService.showPopup("Success", "Please check your email for password reset link.");
        //this.nav.setRoot('DashboardPage',{});

      } else {
        this.showError(this.sharedClass.messages.InvalidEmail);
      }
    },
    error => {
      this.showError(error);
    });
  }

  
  showError(text) {
    this.commonService.dismisshowoading();

    let alert = this.alertCtrl.create({
      title: 'Fail',
      subTitle: text,
      buttons: ['OK']
    });
    //alert.present(promt)
    alert.present();
  }
}




// WEBPACK FOOTER //
// ./src/pages/login/forgot.ts